<div class="row" *ngIf="service">
    <div class="col-12 col-md-12 pt-4 pl-4 pr-4 expanded-list">
      <div class="content">
  
        <div class="row ">
          <div class="col-md-3 milli">{{ 'Publisher' | translate }} / {{ 'Date' | translate }}</div>
          <div class="col-md-3 milli">{{ 'Destination' | translate }}</div>
          <div class="col-md-3 milli">{{ 'Status' | translate }}</div>
          <div class="col-md-3 milli">{{ 'Total publish time' | translate }}</div>
        </div>
        <div
          *ngFor="let p of publishList"
          class="item row py-2"
          (click)="showFailReason(p)">
          <div class="col-md-3 milli mb-0 text-left">
            <span class="item-author d-block">{{  formatPublisher(p.username) }}</span>
            <strong class="item-date d-block">{{ p.date | date: 'dd-MM-yyyy H:mm' }}</strong>
          </div>
          <div class="col-md-3 align-items-center">{{  ( p.destination ? p.destination : "locally") | translate }}</div>
          <div class="col-md-3 align-items-center">
            <div class="text-success" *ngIf="p.publishTotalTime===undefined">{{ 'in progress' | translate }}</div>
            <div class="text-success" *ngIf="p.failReason===undefined && p.publishTotalTime!==undefined">{{ 'success' | translate }}</div>
            <div class="text-danger" *ngIf="p.failReason!=undefined && p.publishTotalTime!==undefined"
              tooltip="{{ 'Click to see reason' | translate }}">{{ 'failed' | translate }}</div>
          </div>
          <div class="col-md-3 align-items-center">{{ convertMillisecToMinSec(p.publishTotalTime) }}</div>
          <div style="margin-bottom: -8px;" class="col-12 bg-light py-3" *ngIf="p.showReason" [innerHTML]="p.failReason | safeHtml"></div>
        </div>
        <div class="app-pagination row" *ngIf="maxPage > 0">
          <ul class="pagination">
            <li class="page-item" *ngIf="page > 0">
              <a class="page-link" (click)="getPage(page - 1)">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li
              *ngFor="let p of getPages()"
              class="page-item"
              [ngClass]="{'active': p === page}">
              <a
                (click)="getPage(p)"
                class="page-link">
                {{p + 1}}
              </a>
            </li>
            <li class="page-item" *ngIf="page < maxPage">
              <a class="page-link" (click)="getPage(page + 1)">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </div>
  
      </div>
    </div>
  </div>
  